import { TypeResponse } from 'gtd-ng-widget';

export class TermsResponse extends TypeResponse {
  crm_terms: {
    agree_date: string;
    agreed: boolean;
    document: CrmDocument;
  }[];
}

interface CrmDocument {
  id: number;
  name: string;
  text: string;
}
